import React from 'react';
import PropTypes from 'prop-types';
import Tile from './Tile';
import VisibilitySensor from 'react-visibility-sensor';

export default class Disciplines extends React.PureComponent {
    static propTypes = {
        disciplines: PropTypes.object
    };
    state = {
        animFired: false
    };

    items = [];

    onStaggerIn = (isVisible) => {
        const items = this.items || [];
        if (isVisible && !this.state.animFired && items.length > 0) {
            TweenMax.staggerFromTo(
                items,
                1.25,
                {x: 100, autoAlpha: 0},
                {
                    x: 0,
                    autoAlpha: 1,
                    ease: Power3.easeOut,
                    onComplete: this.hasCompleted()
                },
                0.3
            );
        }
    };

    hasCompleted = () => {
        this.setState({animFired: true});
    };

    render() {
        const {disciplines} = this.props;
        const {subTitle, title} = disciplines;
        const items = disciplines.discipline || [];

        let colLg = 3;
        if (items.length > 2) {
            colLg = 4;
        }

        return (
            <section className="careers-discipline-overview">
                <div className="careers-section-header">
                    <h1>{title}</h1>
                    <div className="h2">{subTitle}</div>
                </div>
                <div className={`container-fluid ${colLg === 4 && 'max-three'}`}>
                    <VisibilitySensor
                        onChange={this.onStaggerIn}
                        partialVisibility
                        scrollCheck={false}
                        scrollDelay={10}>
                        <div className="row">
                            {items !== undefined && items.length > 0 ? (
                                items.map((item, index) => {
                                    const i = index;
                                    return (
                                        <div
                                            key={`item${i}`}
                                            ref={(c) => {
                                                this.items[i] = c;
                                            }}>
                                            <Tile
                                                title={item.title}
                                                url={item.url}
                                                description={item.description}
                                                image={item.image}
                                                credits={item.credits}
                                                colLg={`col-lg-${colLg}`}
                                            />
                                        </div>
                                    );
                                })
                            ) : (
                                <div />
                            )}
                        </div>
                    </VisibilitySensor>
                </div>
            </section>
        );
    }
}
